import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from 'services/config';
import { SearchResponse } from '@/models/search';
import { prepareHeaders } from '@/state/slices/index';

export const SearchAPI = createApi({
  reducerPath: 'SearchAPI',
  baseQuery: fetchBaseQuery({
    baseUrl: config.BASE_URL,
    prepareHeaders,
  }),
  endpoints: (builder) => ({
    search: builder.query<SearchResponse, string>({
      query: (q) => ({
        url: 'search/',
        params: { q },
      }),
    }),
  }),
});

export const { useSearchQuery } = SearchAPI;
